module.exports = __webpack_public_path__ + "static/getting-started-with-ecommerce-feeds-8da38eccb6fbabba1d25a359aa5f6d14.jpg";